class PackSelector extends HTMLElement {
  connectedCallback() {
    this.optionButtons = [...this.querySelectorAll('[data-pack-value]')];
    this.quantityInput = this.findQuantityInput();

    if (!this.optionButtons.length || !this.quantityInput) return;

    this.optionButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectPack(button));
    });

    this._onQuantityChange = () => this.syncFromQuantity();
    this.quantityInput.addEventListener('change', this._onQuantityChange);

    const defaultPackValue = this.dataset.defaultPackValue;
    const defaultButton = defaultPackValue
      ? this.optionButtons.find(
          (button) => button.dataset.packValue === defaultPackValue
        )
      : null;

    if (defaultButton) {
      this.selectPack(defaultButton);
    } else {
      this.syncFromQuantity();
    }
  }

  disconnectedCallback() {
    if (this.quantityInput && this._onQuantityChange) {
      this.quantityInput.removeEventListener('change', this._onQuantityChange);
    }
  }

  findQuantityInput() {
    const section =
      this.closest('.shopify-section') || this.closest('section');
    return section?.querySelector(
      'quantity-selector input[name="quantity"]'
    );
  }

  selectPack(button) {
    const value = Number(button.dataset.packValue);
    if (!this.quantityInput || !value) return;

    const min = Number(this.quantityInput.min) || 1;
    const max = this.quantityInput.max
      ? Number(this.quantityInput.max)
      : null;

    let nextValue = value;
    if (nextValue < min) nextValue = min;
    if (max && nextValue > max) nextValue = max;

    this.quantityInput.value = String(nextValue);
    this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    this.setActive(button);
  }

  syncFromQuantity() {
    if (!this.quantityInput) return;

    const current = String(this.quantityInput.value);
    const matching = this.optionButtons.find(
      (button) => button.dataset.packValue === current
    );

    if (matching) {
      this.setActive(matching);
    } else {
      this.clearActive();
    }
  }

  setActive(button) {
    this.optionButtons.forEach((option) => {
      option.classList.remove('is-active');
      option.setAttribute('aria-checked', 'false');
    });
    button.classList.add('is-active');
    button.setAttribute('aria-checked', 'true');
  }

  clearActive() {
    this.optionButtons.forEach((option) => {
      option.classList.remove('is-active');
      option.setAttribute('aria-checked', 'false');
    });
  }
}

customElements.get('pack-selector') ||
  customElements.define('pack-selector', PackSelector);
